import { BcInfo } from './general';

export type DashboardMode = 'GROUPS' | 'INDIVIDUAL';

export interface Group {
  id: string;
  name: string;
  source: GroupSource;
  browsingCriteria: BcInfo;
  contactInfo: ContactInfo;
  notes?: string;
  creationDateTime: string;
  assigned: Assignee[] | null;
  agentOfRecord: AgentOfRecord | null;
  lastUpdateTime: string;
  archived: boolean;
  additionalAORs: RenewalAgentOfRecord[];
}

export interface RenewalAgentOfRecord extends AgentOfRecord {
  email: string;
  firstName: string;
  lastName: string;
}

export interface Agency {
  id: string;
  name: string;
}
export interface Address {
  city?: string;
  street?: string;
  zip?: string;
  state?: string;
  street2?: string;
  county?: string;
}

export interface ContactInfo {
  firstName?: string;
  lastName?: string;
  primaryPhone?: string;
  primaryEmail?: string;
  primaryAddress: Address;
  title?: string;
}

export interface AgentOfRecord {
  id: string;
  name: string;
  npn: string;
  email: string;
  type: AssigneeType;
}

export interface Assignee {
  id: string;
  name: string;
  type: AssigneeType;
  npn?: string;
}

export interface InputGroup {
  id: string;
  name: string;
  source: string;
  effectiveDate: string;
  contactInfo: InputContactInfo;
  notes?: string;
  agentOfRecord: InputAgentOfRecord | null;
}

export interface InputAddress {
  city?: string;
  street?: string;
  street2?: string;
  zip?: string;
  state?: string;
  county?: string;
}

export interface InputContactInfo {
  firstName?: string;
  lastName?: string;
  primaryPhone?: string;
  primaryEmail?: string;
  title?: string;
  primaryAddress: InputAddress;
}

export type InputAgentOfRecord = Omit<AgentOfRecord, 'type'>;

// enums

export enum GroupSource {
  ESTORE = 'ESTORE',
  /**
   * @deprecated
   */
  AGENT = 'AGENT',
  AGENT_V2 = 'AGENT_V2',
  SYNC = 'SYNC',
}
export enum AssigneeType {
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  AGENT = 'AGENT',
  TEAM = 'TEAM',
}
